export const toggle = () => {
  $('.toggle > :first-child').click(function (e) {
    e.stopPropagation();
    $(this).closest('.toggle').toggleClass('is-open');
  });

  $('.toggle').first().addClass('is-open');
};
